import React from "react";
import { EarthText } from '../../components';
import { connect } from 'react-redux';

const Notifications = () => (
  <div className="EarthHeader__information_container_notification border-left">
    <button
      type="button"
      id="notification-dropdown"
      data-toggle="dropdown"
    >
      <i className="fas fa-bell" />
      {<span className="counter">{2}</span>}
    </button>

    <div
      className="dropdown-menu dropdown-menu-right"
      aria-labelledby="currency-dropdown"
    >
      <span className="dropdown-item">
        <div className="notification-item">
          <EarthText>View all Notifications</EarthText>
        </div>
      </span>
    </div>
  </div>
)

const mapStatetoProps = state => {
  return {
    earthName: state.root.user.earthName,
  };
}

export default connect(mapStatetoProps)(Notifications);

